import { useAtomValue } from "jotai";
import { pageTitleAtom } from "@/stores/atoms/page-title-atom";

const DynamicPageHeader = () => {
  const title = useAtomValue(pageTitleAtom);

  if (!title) return null;

  return (
    <div className="flex-1 flex items-center justify-between w-full">
      <h1 className="lg:text-lg text-gray-500">{title}</h1>
    </div>
  );
};

export default DynamicPageHeader;
